import { render, staticRenderFns } from "./ConocenosWorld.vue?vue&type=template&id=796cb0ca"
import script from "./ConocenosWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./ConocenosWorld.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/css/Conocenos/conocenos.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports